/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Car\Car.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Monday June 12th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 27th September 2024 03:49:43
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { CarPictureType } from "Type/singleCarDbType";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useLoaderData } from "react-router-dom";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Car/Car.module.css";
import BackArrow from "Content/BackArrow/BackArrow";
import dateFormat from "dateformat";
import { FiExternalLink } from "react-icons/fi";
import "Content/Car/Car.css";
import DragGalery from "Content/DragGalery/DragGalery";
import CarInfo from "Content/Car/CarData";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import { UpdateCarInfo, UpdateCarType } from "Type/CarElement.type.hold";
import CarService from "Services/Car/CarService";
import ModalCarPicture from "Content/Modals/ModalCarPicture/ModalCarPicture";
import { Form } from "react-bootstrap";
import ModalSearchUser from "Content/Modals/ModalSearchUser/ModalSearchUser";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import { CarEquipment } from "Content/Equipment/CarEquipment";
import { ConvertParkToString } from "Utils/car.utils";
import CollapseDiv from "Content/CollapseDiv/CollapseDiv";
import CarSelect from "./CarSelect/CarSelect";
import OfferTableUser from "Content/Offers/OfferTableUser/OfferTableUser";
import Config from "Config/Config";
import AddOfferOnCar from "Content/AddOfferOnCar/AddOfferOnCar";

type CarInputType = string | number | Date | boolean | null;

type building = {
    [valName: string]: [CarInputType, Function]
};

export default function CarElement() {
    const loadData = useLoaderData() as {editable: boolean, id: string, promises: Promise<any>[]};
    const [editable, setEditable] = useState(loadData.editable ?? false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState(false);
    const updateData = useRef<UpdateCarType>({update: {updated: false}, create: {}, delete: {}});
    const myCardTitle = useState("");
    const myRegNb = useState("");
    const myVIN = useState("");
    const myBrand = useState("");
    const myModel = useState("");
    const myVersion = useState("");
    const myMileage = useState("");
    const myCirculationDate = useState<Date>(new Date());
    const myEnergy = useState("");
    const myVAT = useState("");
    const myGears = useState("");
    const myUrl = useState("");
    const myCustomText = useState("");
    const mySubSection = useState("");
    const myIsPromo = useState("");
    const myTypeID = useState("");
    const myParkID = useState("");
    const myColor = useState("");
    const myStatus = useState("");
    const myPriceBuyNow = useState(0);
    const myDamageCost = useState<number>(0);
    const [commentary, setCommentary] = useState("");
    const [carCustomSubTitle, setCarCustomSubTitle] = useState("");
    const [pictureList, setPictureList] = useState<CarPictureType[]>([]);
    const picturesRef = useRef<CarPictureType[]>([]);
    const [boxes, setBoxes] = useState(pictureList.map((val)=> {return {id: val.id, order: val.Index, Name: val.Pict.Name, Url: val.Pict.URI, toDelete: false }}));

    const dataLeftColumn: building = {"RegNb": myRegNb, "VIN": myVIN, "Brand": myBrand, "Model": myModel, "Version": myVersion, "CirculationDate": myCirculationDate };
    const dataRightColumn = { "Color": myColor, "TypeID": myTypeID, "SubSection": mySubSection, "Energy": myEnergy, "Gears": myGears};
    const dataPricingLeft = {"isPromo": myIsPromo, "Mileage": myMileage, "myPriceBuyNow": myPriceBuyNow, "CustomText": myCustomText, "StoragePlace": myParkID, "VAT": myVAT, "damageCost": myDamageCost, "myInspectionURL": myUrl};

    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openPictureModal, setOpenPictureModal] = useState<boolean>(false);
    const [openSendCarModal, setOpenSendCarModal] = useState<boolean>(false);

    useEffect(()=>{
        Promise.all(loadData.promises).then(([car, CarPicture]) => {
            setPictureList((CarPicture as CarPictureType[]).sort((val1, val2) => val1.Index - val2.Index));
            CarPicture.forEach((element: CarPictureType) => {
                picturesRef.current.push(
                    {...element}
                );
            });
            myRegNb[1](car.RegNb);
            myVIN[1](car.VIN ? car.VIN : "");
            myBrand[1](car.Brand);
            myModel[1](car.Model);
            myVersion[1](car.Version);
            myCirculationDate[1](new Date(car.CirculationDate));
            myEnergy[1](car.Energy.Name);
            myGears[1](car.Gears);
            mySubSection[1](car.SubSection);
            myTypeID[1](car.CarType.Name);
            myColor[1](car.Color);
            myStatus[1](car.InSell[0].Status);
            myVAT[1](car.InSell[0].VAT);
            myIsPromo[1](car.InSell[0].isPromo);
            myMileage[1](car.InSell[0].Mileage);
            myCustomText[1](car.InSell[0].CustomText);
            myParkID[1](ConvertParkToString(car.InSell[0].StoragePlace));
            myPriceBuyNow[1](car.InSell[0].SellPrice !== null ? car.InSell[0].SellPrice : 0);
            myUrl[1](car.Link ?? "");
            myDamageCost[1](car.InSell[0].RepairVal ?? 0);
            setCommentary(car.Comments);
            myCardTitle[1](car.Brand + " " + car.Model);
            setCarCustomSubTitle(car.Model + " " + car.Version);
        });
    }, []);

    const manageSelectUpdate = (newData: string, previous: string, key: string) => {
        let datatoUpdate = updateData.current.update.carData;
        if (newData !== previous) {
            if (!updateData.current.update.carData)
                updateData.current.update.carData = {};
            updateData.current.update.updated = true;
            updateData.current.update.carData[key] = newData;
        } else if (datatoUpdate && datatoUpdate[key])
            datatoUpdate[key] = undefined;
    };

    function InputCar(valueName: string, carValue: CarInputType, carValueSetter: Function, idx: number) {
        let myInput: JSX.Element | null = null;

        switch (typeof carValue) {
            case "string":
                if (valueName.includes("URL"))
                    myInput = <div className={`${carValue.length > 30 ? "w-75": "" } ${Styles.urlLink}`}>
                            {
                                carValue ?
                                <FiExternalLink onClick={() => {window.open(carValue)}}/> : null
                            }
                            <input type="text" className={`${carValue.length > 30 ? "w-100": "" } text-uppercase`} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.value); carValueSetter(e.target.value.toString())}} value={carValue} disabled={!editable} />
                        </div>;
                else if (valueName.includes("Gears"))
                    myInput = <CarSelect item={myGears[0]} updateFunc={manageSelectUpdate} updateKey={"Gears"} optionsList={Config.COMMON.GEARS} keyTrad={"car.gears"} disabled={editable} />
                else if (valueName.includes("SubSection"))
                    myInput = <CarSelect item={mySubSection[0]} updateFunc={manageSelectUpdate} updateKey={"SubSection"} optionsList={["sedan", "suv", "break", "citycar", "utility", "unknown"]} keyTrad={"carType"} disabled={editable} />
                else if (valueName.includes("Energy"))
                    myInput = <CarSelect item={myEnergy[0].toUpperCase()} updateFunc={manageSelectUpdate} updateKey={"Energy"} optionsList={["diesel", "gasoline", "biofuel", "electric", "hybrid", "other"]} keyTrad={"energyType"} disabled={editable} />
                else if (valueName.includes("CustomText"))
                    myInput = <input maxLength={16} type="text" onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.value); carValueSetter(e.target.value.toString())}} value={carValue} disabled={!editable} />
                else
                    myInput = <input type="text" className={`${carValue.length > 30 ? "w-75": "" } text-uppercase`} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.value); carValueSetter(e.target.value.toString())}} value={carValue} disabled={!editable} />;
                break;
            case "number":
                myInput = <input type="number" min={0} step={100} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, parseInt(e.target.value)); carValueSetter(parseInt(e.target.value))}} value={carValue < 0 ? 0 : carValue } disabled={!editable} />
                break;
            case "boolean":
                myInput = <div style={{flexDirection: "row", display: "flex"}}>
                        <span>{translator.decode("dynamic.no")}</span>
                            <Form.Check className="ms-2" type="switch" checked={carValue} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.checked); carValueSetter(e.target.checked)}} disabled={!editable}/>
                        <span>{translator.decode("dynamic.yes")}</span>
                    </div>;
                break;
            case "object":
                if (carValue === null)
                    break;
                let date = dateFormat(carValue, "yyyy-mm-dd");
                myInput = <input type="date" onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, new Date(e.target.value)); carValueSetter(new Date(e.target.value))}} value={date} disabled={!editable} />;
                break;
            default:
                break;
        };
        return <div key={`${valueName}-${idx}`} className="d-flex justify-content-between">
                    <span className="text-capitalize"> {translator.decode(`car.${valueName}`)} </span>
                    {myInput}
                </div>;
    };

    const handleCarDataUpdate = (attrName: keyof UpdateCarInfo, value: any, idx?: number) => {
        let datatoUpdate = updateData.current.update.carData;
        if (!datatoUpdate)
            datatoUpdate = {};
        if (attrName in datatoUpdate) {
            if (idx) {
                if (attrName in updateData.current.update && datatoUpdate[attrName] === undefined)
                    Object.defineProperty(datatoUpdate, attrName, [] as string[]);
                datatoUpdate[attrName] = value;
            } else
                datatoUpdate[attrName] = value;
            updateData.current.update.updated = true;
        } else if (attrName.length > 0) {
            if (idx) {}
            else
                datatoUpdate[attrName] = value;
            updateData.current.update.updated = true;
        }
        updateData.current.update.carData = datatoUpdate;
    };

    const handleSubmit = async () => {
        setSpinner(true);
        if (updateData.current.update.updated) {
            let updated = false;
            if (updateData.current.update.carData || updateData.current.create.EquipmentsToCreate || updateData.current.delete.EquipmentsToDelete) {
                let car = await CarService.setCarByID(loadData.id, updateData.current);
                if (car)
                    updated = true;
            }
            var tmp: CarPictureType[] = [];
            if (updateData.current.delete.PictureToDelete !== undefined) {
                tmp.push(...pictureList.filter(x => !x.toDelete).sort((y, z) => y.Index - z.Index).map((val, idx) => {return { ...val, Index: idx}}));
                var toUpdate = [];
                for (let item of picturesRef.current) {
                    const match = tmp.find(x => x.id === item.id && item.Index !== x.Index);
                    if (match)
                        toUpdate.push(match);
                }
                updateData.current.update.pictureData = toUpdate;
            }
            if (updateData.current.update.pictureData) {
                let car = await CarService.setCarPicturesByID(loadData.id, updateData.current);
                if (car) {
                    updated = true;
                    if (tmp.length > 0)
                        setPictureList(tmp);
                    updateData.current.delete.PictureToDelete = [];
                }
            }
            if (updated) {
                setIsOkay(true);
                setOpenModal(true);
            } else {
                setIsOkay(false);
                setOpenModal(true);
            }
        }

        updateData.current.update.updated = false;
        setSpinner(false);
    };

    const buildRows = (input: building) => {
        let myRows: JSX.Element[] = [];
        Object.entries(input).forEach((val, index) => {
            myRows.push(InputCar(val[0], val[1][0], val[1][1], index));
        });
        return myRows;
    };

    const myDataLeft = useMemo(() => {
        return buildRows(dataLeftColumn);
    }, [myRegNb[0], myVIN[0], myBrand[0], myModel[0], myVersion[0], myCirculationDate[0], editable]);

    const myDataRight = useMemo(() => {
        return buildRows(dataRightColumn);
    }, [myColor[0], myTypeID[0], mySubSection[0], myEnergy[0], myGears[0], editable]);

    const myPricingLeftRows = useMemo(() => {
        return buildRows(dataPricingLeft);
    }, [myPriceBuyNow[0], myIsPromo[0], myMileage[0], myCustomText[0], myParkID[0], myVAT[0], myDamageCost[0], myUrl[0], editable]);

    useEffect(() => {
        setBoxes(pictureList.map(val => {return {id: val.id, order: val.Index, Name: val.Pict.Name, Url: val.Pict.URI, toDelete: val.toDelete}}));
    }, [pictureList]);

    const handlePictureDelete = ((id: string) => {
        let picture = pictureList.find((val) => val.id == id);
        if (!picture)
            return null;
        if (!updateData.current.delete.PictureToDelete)
            updateData.current.delete.PictureToDelete = [];
        updateData.current.delete.PictureToDelete.push(picture.id);
        picture.toDelete = true;
        updateData.current.update.updated = true;
        setPictureList([...pictureList]);
    });

    const handleRetrievePictures = () => {
        setSpinner(true);
        CarService.retrievePicturesForCar(loadData.id).then(() => {
            setIsOkay(true);
            setOpenModal(true);
            setSpinner(false);
        }).catch(() => {
            setIsOkay(false);
            setOpenModal(true);
            setSpinner(false);
        });
    };

    const handlePictureUpdate = (boxes: any[], ...updatedBoxes: any[]) => {
        updateData.current.update.updated = true;
        updateData.current.update.pictureData = updateData.current.update.pictureData?.filter((val) => !updatedBoxes.map(v => v.id).includes(val.id));
        updateData.current.update.pictureData = [...(updateData.current.update.pictureData ?? []), ...updatedBoxes.map((val) => {
            return {
                id: val.id,
                Index: val.order
            };
        })];
        for (let box of updatedBoxes) {
            let picture = pictureList.find(val => val.id === box.id);
            if (picture)
                picture.Index = box.order;
        }
        setPictureList([...pictureList]);
    };

    const getStatusStyle = (style: string) => {
        var myClass: string = "";
        switch (style.toUpperCase()) {
            case "SOLD":
                myClass = Styles.sold;
                break;
            case "RESERVED":
                myClass = Styles.reserved;
                break;
            default:
                break;
        }
        return myClass;
    };

    const onOffer = async (func: Function) => {
        setSpinner(true);
        func().then(() => {
            setSpinner(false);
            setIsOkay(true);
            setOpenModal(true);
        }).catch(() => {
            setSpinner(false);
            setIsOkay(false);
            setOpenModal(true);
        });
    };

    return(
        <Fragment>
            {
                spinner ?
                    <div className={`${Styles.spinnerHolder}`}>
                        <LoadingScreen />
                    </div>
                    :null
            }
            <div className={`${Styles.carHolder}`}>
                <h1 className={`${Styles.title}`}> {myCardTitle[0].toUpperCase()} </h1>
                <h3 className={`${Styles.title}`}> {myVersion[0].toUpperCase()} </h3>
                <div className={`${Styles.title} ${Styles.carStatus}`}>
                    <h3 className={`${getStatusStyle(myStatus[0])}`}>{translator.decode(`car.status.${myStatus[0].toLowerCase()}`)}</h3>
                    {
                        editable ?
                        <CarSelect item={myStatus[0]} updateFunc={manageSelectUpdate} updateKey={"Status"} optionsList={Config.COMMON.CARSTATUS} keyTrad={"car.status"} label={translator.decode("dynamic.status")} disabled={editable} />
                        : null
                    }
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <BackArrow />
                    <div className={`${Styles.actionBtn}`}>
                        <button className="btn btn-outline-warning" onClick={(e) => setEditable(!editable)}> {editable ?  translator.decode("dynamic.classicView") : translator.decode("car.Edit") } </button>
                        <button className="btn btn-outline-info" onClick={() => setOpenSendCarModal(true)}> {translator.decode("car.SendCarToClient")} </button>
                        {
                            editable ?
                            <>
                                <button className="btn btn-outline-info" onClick={(e) => setOpenPictureModal(true)}> {translator.decode("car.add_pictures")} </button>
                                <button className="btn btn-outline-primary" onClick={handleRetrievePictures}> {translator.decode("car.get_pictures")} </button>
                                <button className="btn btn-outline-success" onClick={handleSubmit}> {translator.decode("car.Save")} </button>
                            </>
                            : null
                        }
                    </div>
                </div>
                <CollapseDiv title={translator.decode("car.Galery")}>
                    <DragGalery editable={editable} items={boxes} func={handlePictureUpdate} onDelete={handlePictureDelete}/>
                </CollapseDiv>
                <CollapseDiv title={translator.decode("car.CarData")}>
                    <CarInfo editable={editable} updatedCarObject={updateData.current} commentary={commentary} changeCommentary={(val: string) => { handleCarDataUpdate("Comments", val); setCommentary(val); } } carCustomSubTitle={carCustomSubTitle} changeCarCustomSubTitle={setCarCustomSubTitle}
                     dataLeftColumn={myDataLeft} dataRightColumn={myDataRight}
                     dataPricingLeft={myPricingLeftRows} dataPricingRight={[]} dataURL={[]} />
                </CollapseDiv>
                <CarEquipment carUpdate={updateData.current} id={loadData.id} disabled={editable} />
                <CollapseDiv title={translator.decode("dynamic.offers")}>
                    <>
                        <AddOfferOnCar carID={loadData.id} onOffer={onOffer} price={myPriceBuyNow[0]} />
                        <OfferTableUser showUser={true} carID={loadData.id} />
                    </>
                </CollapseDiv>
            </div>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} />
            <ModalCarPicture title={translator.decode("car.add_pictures")} carID={loadData.id} carIdx={boxes.length} show={openPictureModal} onClose={() => setOpenPictureModal(false)} closeModal={() => setOpenPictureModal(false)} name={myRegNb[0].toString()} />
            <ModalSearchUser carID={loadData.id} show={openSendCarModal} onClose={() => setOpenSendCarModal(false)} closeModal={() => setOpenSendCarModal(false)} title={translator.decode("car.SendCarToClient")} />
        </Fragment>
    )
}
